import { Employee } from './Employee';
import { make } from './Model';

export class PodShuffleAsyncTask {
  id = '';

  status = '';

  numRows = 0;

  rawFileId?: number;

  errorFileId?: number;

  createdAt = 0;

  updatedAt = 0;

  createdBy: Employee;

  updatedBy: Employee;

  constructor(obj: any) {
    Object.assign(this, obj);
    this.createdBy = make(obj.createdBy, Employee);
    this.updatedBy = make(obj.updatedBy, Employee);
  }
}
